import React from 'react'
import RiskIndicator from '../../../Home/components/RiskIndicator/RiskIndicator';
 

export default function RiskWidget(props: { title: string }) {
  const { title } = props;

  return (
    <div className="widget">
      {/* header */}
      <div className="d-flex align-items-center justify-content-between">
        <h3 className="widget-title">{title}</h3>

        <button className="btn btn-flat text-white flex-center">
          View Report
          <i className="icon-arrow-right text-5c ml-2"></i>
        </button>
      </div>
      {/* Header */}

      <h6 className="text-gray-400 fw-300">
        3
        <small className="text-gray-500 ml-1">
          employees are underutilized
        </small>
      </h6>

      <div className="row mt-5">
        <div className="col">
          <RiskIndicator
            title="High Rated Risks"
            description="We’ve shown you almost 400 risks that would have affected your organization."
            value="1244"
            subValue="100"
            arrowColor="text-info"
          />
        </div>
        <div className="col">
          <RiskIndicator
            title="Medium Rated Risks"
            description="We’ve shown you almost 400 risks that would have affected your organization."
            value="643"
            subValue="100"
            arrowColor="text-danger"
          />
        </div>
        <div className="col">
          <RiskIndicator
            title="Low Rated Risks"
            description="We’ve shown you almost 400 risks that would have affected your organization."
            value="2134"
            subValue="100"
            arrowColor="text-warning"
          />
        </div>
        <div className="col">
          <RiskIndicator
            title="Not Rated"
            description="We’ve shown you almost 400 risks that would have affected your organization."
            value="7645"
            subValue="12"
            arrowColor="text-info"
          />
        </div>
      </div>
    </div>
  );
}
